<template>
    <div class="ci-container" :style="computedProps.container">
        <span class="ci-circle"/>
        <span class="ci-line" :style="computedProps.line"/>
        <p :style="computedProps.textPos">{{computedProps.text}}</p>
    </div>
</template>

<script>
    export default {
        name: "ChartIndicator",
        props: ['computedProps']
    }
</script>

<style lang="scss">
    .ci-container {
        position: absolute;
        .ci-circle {
            position: absolute;
            display: block;
            width: 10px;
            height: 10px;
            border: 1px solid white;
            border-radius: 16px;
        }
        .ci-line {
            position: absolute;
            display: block;
            width: 30px;
            height: 1px;
            margin: 4px 0 4px 9.5px;
            background: white;
            transform-origin: -5px center;
        }
        p {
            position: absolute;
        }
    }

</style>